import React, { Component } from 'react'

import './tableContainer.scss'

class TableContainer extends Component {
  getStyle () {
    let classNames = 'element-table-row-container'

    if (this.props.fullWidth) {
      classNames += ' element-table-row-container--full-width'
    }
    if (this.props.fullHeight) {
      classNames += ' element-table-row-container--full-height'
    }

    return classNames
  }

  render () {
    return (
      <div className={this.getStyle()}>
        {this.props.children}
      </div>
    )
  }
}

TableContainer.defaultProps = {
  fullWidth: false,
  fullHeight: false
}

export default TableContainer



// WEBPACK FOOTER //
// ./src/app/shared/elements/tableContainer/index.js